import {
  COMPARISON_OPERATORS,
  SCAN_SERVICE_STATUS,
} from '@witmetrics/utils/constants';
import { buildColumnFilter } from '@witmetrics/utils/filters';

const { IN_PROGRESS } = SCAN_SERVICE_STATUS;

export const PAGE_SIZE = 20;

export const PENDING_FILTER = buildColumnFilter(
  'status',
  COMPARISON_OPERATORS.EQUALS.value,
  IN_PROGRESS
);
